import {
	hasLastSrpUrlInStorage,
	refreshLastSrpUrlActivity
} from '~/composables/lastSrpUrl/utils';

const ACTIVITY_EVENTS = ['click', 'scroll'] as const;
const ACTIVITY_REFRESH_THROTTLE_MS = 1000;
const ACTIVITY_EVENT_OPTIONS: AddEventListenerOptions = {
	capture: true,
	passive: true
};

let lastRefresh = 0;
let activityListenersController: AbortController | null = null;

function getActivityEventOptions(signal: AbortSignal): AddEventListenerOptions {
	return {
		...ACTIVITY_EVENT_OPTIONS,
		signal
	};
}

function refreshActivity(): void {
	const now = Date.now();
	if (now - lastRefresh < ACTIVITY_REFRESH_THROTTLE_MS) return;

	lastRefresh = now;
	refreshLastSrpUrlActivity();

	if (!hasLastSrpUrlInStorage()) {
		cleanupLastSrpUrlActivityListeners();
	}
}

export function cleanupLastSrpUrlActivityListeners(): void {
	if (!import.meta.client) return;

	activityListenersController?.abort();
	activityListenersController = null;
	lastRefresh = 0;
}

export function setupLastSrpUrlActivityListeners(): void {
	if (
		!import.meta.client ||
		activityListenersController ||
		!hasLastSrpUrlInStorage()
	) {
		return;
	}

	activityListenersController = new AbortController();
	const { signal } = activityListenersController;

	ACTIVITY_EVENTS.forEach(eventName => {
		window.addEventListener(
			eventName,
			refreshActivity,
			getActivityEventOptions(signal)
		);
	});

	window.addEventListener('pagehide', cleanupLastSrpUrlActivityListeners, {
		once: true,
		signal
	});

	refreshActivity();
}
